import { type Ref } from 'react';

import { mergeSx } from '../../util/mui/sx';

import { Box, type BoxProps } from './Box';

export interface CenteredProps extends Omit<BoxProps, 'ref'> {
  readonly aspectRatio?: null | number;
  readonly ref?: Ref<HTMLDivElement>;
}

export const Centered = ({ aspectRatio = 1, children, ref, ...props }: CenteredProps) => (
  <Box
    height='100%'
    width='auto'
    {...props}
    ref={ref}
    sx={mergeSx(props.sx, {
      alignItems: 'center',
      aspectRatio: typeof aspectRatio === 'number' ? aspectRatio : undefined,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    })}
  >
    {children}
  </Box>
);
